<kendo-grid
  class="flow-actions"
  [data]="view"

  [sort]="state.sort"
  [sortable]="true"
  [filter]="state.filter"
  [selectable]="true"
  filterable="menu"
  (dataStateChange)="dataStateChange($event)"
  [scrollable]="'virtual'"
  [style.height.%]="100"

  [kendoGridSelectBy]="'name'"

  #actionsgrid
  >
  <kendo-grid-column field="name" title="Name" [width]="200">
  </kendo-grid-column>
  <kendo-grid-column field="status" title="Status" [width]="100">
  </kendo-grid-column>
  <kendo-grid-column field="code" title="Code" [width]="100">
  </kendo-grid-column>
  <kendo-grid-column field="error" title="Error" [width]="100">
    <ng-template kendoGridCellTemplate let-dataItem>
      {{dataItem.error | json}}
    </ng-template>
  </kendo-grid-column>
  <kendo-grid-column field="inputsLink" title="Input" [width]="100" class="cell">
    <ng-template kendoGridCellTemplate let-dataItem>
      @if (dataItem.inputsLink) {
        <a href='{{dataItem.inputsLink}}' target='_blank'>{{dataItem.inputsLink}}</a>
      }
    </ng-template>
  </kendo-grid-column>
  <kendo-grid-column field="outputsLink" title="Output" [width]="100" class="cell">
    <ng-template kendoGridCellTemplate let-dataItem>
      @if (dataItem.outputsLink) {
        <a href='{{dataItem.outputsLink}}' target='_blank'>{{dataItem.outputsLink}}</a>
      }
    </ng-template>
  </kendo-grid-column>
  <kendo-grid-column field="startTime" title="Start" type="date" format="{0:y-MM-dd HH:mm:ss a}" filter="date" [width]="200">
  </kendo-grid-column>
  <kendo-grid-column field="endTime" title="End" type="date" format="{0:y-MM-dd HH:mm:ss a}" filter="date" [width]="200">
  </kendo-grid-column>
  <kendo-grid-column field="duration" title="Duration" type="number" format="{0:g}" [width]="100">
    <ng-template kendoGridCellTemplate let-dataItem>
      @if (dataItem.endTime) {
        <span>{{dataItem.duration}} ({{dataItem.durationString}})</span>
      }
    </ng-template>
  </kendo-grid-column>
  <kendo-grid-excel fileName="actions.xlsx"></kendo-grid-excel>
</kendo-grid>
<grid-context-menu [for]="actionsgrid" [menuItems]="['Enable', 'Disable', 'Edit JSON']" (select)="onSelect($event)">
</grid-context-menu>
